/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'avi-forms';
const componentName = 'custom-params-grid';
const prefix = `${moduleName}.${componentName}`;

export const columntitleSensitive = `${prefix}.columntitleSensitive`;
export const columntitleDynamic = `${prefix}.columntitleDynamic`;

export const ENGLISH = {
    [columntitleSensitive]: 'Sensitive',
    [columntitleDynamic]: 'Dynamic',
};
